import type { ComponentChildren, JSX, KeyboardEventHandler } from "preact";
import { forwardRef } from "preact/compat";
import { classNames } from "@gss/common/classNames";
import "./Nav.css";

type Variant = "tabs" | "pills" | "navbar";

export interface NavProps {
    variant: Variant;
    vertical?: boolean;
    className?: string;
    children?: ComponentChildren;
    onKeyDown?: KeyboardEventHandler<HTMLUListElement>;
}

export const Nav = forwardRef<HTMLUListElement, NavProps>(
    (
        { variant, vertical, className, children, onKeyDown }: NavProps,
        ref,
    ): JSX.Element => {
        return (
            <ul
                className={classNames(
                    getVariantClass(variant),
                    vertical && "flex-column",
                    className,
                )}
                role={variant !== "navbar" ? "tablist" : undefined}
                onKeyDown={onKeyDown}
                ref={ref}
            >
                {children}
            </ul>
        );
    },
);

Nav.displayName = "Nav";

function getVariantClass(variant: Variant): string {
    switch (variant) {
        case "tabs":
            return "nav nav-tabs";
        case "pills":
            return "nav nav-pills";
        case "navbar":
            return "navbar-nav";
        default: {
            const _exhaustiveCheck: never = variant;
            throw new Error("Unknown variant");
        }
    }
}
